import { SlingoBigWinState } from "slingo/states/slingo-big-win-state";

export class FowlBigWinState extends SlingoBigWinState {
    protected bigWinTriggered(): boolean {
        /**
         * 3 months ago I raised the point that showing the big win both at the end of every feature AND at the
         * end of the game would be redundant and annoying.
         * 
         * Benny's now raised the point that showing the big win both at the end of every feature AND at the
         * end of the game is redundant and annoying.
         */
        return false;
    }
}
